module.exports = "<div class=\"bannerContainer\">\n    <div class=\"wordingContainer\">\n        <div class=\"wording\">Welcome to the Support Portal</div>\n        <div class=\"btnContainer\">\n            <button class=\"asui-btn btn btn-primary\" ng-click=\"$ctrl.goToCreateCase()\">Create a Case</button>\n            <a ng-href=\"{{$ctrl.urlKC}}\" target=\"_blank\"><button class=\"asui-btn btn btn-default\">View Docs</button></a>\n        </div>\n    </div>\n    <div class=\"imgContainer\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/support/components/support-case-banner/supportCaseBanner.component.html
// module id = 727
// module chunks = 0